import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as dataHelper from '../../../helpers/dataHelper';
import videojs from 'video.js';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as userDataHelper from '../../../helpers/userDataHelper';
import * as keyboardConstants from '../../../constants/keyboardConstants';
import * as localStorage from '../../../localStorage/localStorage';
import * as animationHelper from "../../../helpers/animationHelper"; //https://www.npmjs.com/package/react-player
const SHOW_CONTROLS = true;

class VideoJsPlayer extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            userData: this.props.userData,
            screenObject: this.props.screenObject,
            video: this.props.video,
            locale: appHelper.getLocalData(this.props.screenObject),
            responseData: {
                latestResponse: {}
            },
            isPlaying: true,
            status: objectConstants.STATUS_NOT_STARTED,
            isResourceObject: appHelper.isDefined(this.props.callbacks.checkIsResourceScreen) && this.props.callbacks.checkIsResourceScreen(),
            trackable: true,
            autoPlay: true,
            video_instruction: appHelper.getLocaleString("video_instruction"),
            done_label: appHelper.getLocaleString("done_label"),
            cancel_label: appHelper.getLocaleString("cancel_label"),
            download_transcript_label: appHelper.getLocaleString("download_transcript_label"),
            language_name: appHelper.getArrayObjectByKey(localStorage.languages, "language_code", this.props.lang).language_name
        };

        this.handleProgression = this.handleProgression.bind(this);
        this.show = this.show.bind(this);
        this.onStartFunc = this.onStartFunc.bind(this);
        this.onEndedFunc = this.onEndedFunc.bind(this);
        this.onPauseFunc = this.onPauseFunc.bind(this);
        this.onPlayFunc = this.onPlayFunc.bind(this);
        this.setClass = this.setClass.bind(this);
        this.getObjectStatusClass = this.getObjectStatusClass.bind(this);
        this.getVideoPath = this.getVideoPath.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.getControlClass = this.getControlClass.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
        this.readyVideo = this.readyVideo.bind(this);
        this.getCaptionPath = this.getCaptionPath.bind(this);
        this.onReady = this.onReady.bind(this);
        this.onLinkClick = this.onLinkClick.bind(this);

        this.objectRef = React.createRef();
    }

    componentDidMount() {
        this.readyVideo();
        this.show();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.userData !== nextProps.userData) {
            this.setState({userData: Object.assign({}, nextProps.userData)});
        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.state.screenObject),
                video_instruction: appHelper.getLocaleString("video_instruction"),
                done_label: appHelper.getLocaleString("done_label"),
                cancel_label: appHelper.getLocaleString("cancel_label"),
                download_transcript_label: appHelper.getLocaleString("download_transcript_label"),
                language_name: appHelper.getArrayObjectByKey(localStorage.languages, "language_code", nextProps.lang).language_name
            });
        }
    }

    componentWillUnmount() {
        if (this.player) {
            this.player.dispose();
        }
    }

    readyVideo() {
        let isLocal = dataHelper.getFileExtention(this.state.video.src) === "mp4";
        let props = {
            autoplay: true,
            controls: true,
            sources: [{
                src: isLocal ? this.getVideoPath(this.state.video) : this.state.video.src,
                type: 'video/mp4'
            }]
        };

        let ref = this.refs[`video_${this.state.screenObject.asset_id}`];
        this.player = videojs(ref, props, this.onReady);/**/
    }

    getCaptionPath(captions) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(captions) && captions.length > 0) {
                return require(`../../../../moveToDist/${captions}`);
            }
        } else {
            return captions;
        }
    }

    onReady() {
        this.player.on("play", this.onPlayFunc);
        this.player.on("ended", this.onEndedFunc);
    }

    getObjectStatusClass() {
        let objectUserData = {};
        let subScreenParent = {};
        let screen_id = undefined;
        if (appHelper.isDefined(this.props.callbacks.getSubScreenParent)) {
            subScreenParent = this.props.callbacks.getSubScreenParent();
        }
        if (appHelper.isDefined(this.props.callbacks.getScreenId)) {
            screen_id = this.props.callbacks.getScreenId();
        }

        if (appHelper.isDefined(screen_id)) {
            if (appHelper.isDefined(subScreenParent)) {
                objectUserData = userDataHelper.getSubScreenObjectStatus(this.state.userData, subScreenParent.screen_id, screen_id, this.state.screenObject.asset_id);
            } else if (this.state.isResourceObject) {
                objectUserData = userDataHelper.getResourceScreenObjectUserData(this.state.userData, screen_id, this.state.screenObject.asset_id);
            } else {
                objectUserData = userDataHelper.getObjectStatus(this.state.userData, screen_id, this.state.screenObject.asset_id);
            }
        } else {
            objectUserData = userDataHelper.getAttachmentObjectUserData(this.state.userData, this.state.screenObject.asset_id);
        }

        if (appHelper.isDefined(objectUserData.status)) {

            if (objectUserData.status === objectConstants.STATUS_COMPLETE) {
                return `complete`;
            } else if (objectUserData.status === objectConstants.STATUS_IN_PROGRESS) {
                return `in-progress`;
            } else if (objectUserData.status === objectConstants.STATUS_NOT_REQUIRED) {
                return `not-required`;
            } else {
                if (this.state.status === objectConstants.STATUS_COMPLETE) {
                    return `complete`;
                } else if (this.state.status === objectConstants.STATUS_IN_PROGRESS) {
                    return `in-progress`;
                } else {
                    return `not-started`;
                }
            }
        }
        return `not-started`;
    }


    getVideoPath(video) {
        if (video.sub_type == objectConstants.VIDEO_SUB_TYPE_MP4 && appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(video.src) && video.src.length > 0) {
                return require(`../../../../moveToDist/${video.src}`);
            }
        } else {
            return video.src;
        }
    }

    handleProgression() {
        this.props.callbacks.onObjectComplete(objectConstants.OBJECT_PROGRESSION_CONTINUE, this.state.screenObject.asset_id, this.state.responseData.latestResponse);
    }

    //<iframe src={`https://player.vimeo.com/video/${this.state.locale.vimeo_id}`} width="100%" height="auto"  allowFullScreen />

    onStartFunc(event) {
        //console.log(`onStart`);
        this.setState({isPlaying: true});
        this.setState({status: objectConstants.STATUS_IN_PROGRESS});
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoOpened(this.state.screenObject.asset_id, this.state.locale.label);
        }
    }

    onEndedFunc(event) {
        this.props.onAssetViewed();
        this.setState({isPlaying: false});
        this.setState({status: objectConstants.STATUS_COMPLETE});
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoPlayed(this.state.screenObject.asset_id, this.state.locale.label);
        }

    }

    onPauseFunc(event) {
        this.setState({isPlaying: false});
    }

    onPlayFunc(event) {

        this.setState({isPlaying: true});
        if (this.state.status !== objectConstants.STATUS_COMPLETE) {
            this.setState({status: objectConstants.STATUS_IN_PROGRESS});
        }
        if (localStorage.tracking_type === appConstants.TRACKING_TYPE_XAPI || localStorage.tracking_type === appConstants.TRACKING_TYPE_BLENDED_XAPI_SCORM_1_2) {
            this.props.actions.setVideoOpened(this.state.screenObject.asset_id, this.state.locale.label);
        }
    }

    setClass() {
        if (this.state.isPlaying) {
            return "playing";
        } else {
            return "";
        }
    }

    setStatusClass() {

        if (this.state.status === objectConstants.STATUS_COMPLETE) {
            return "viewed";
        } else {
            return "not-viewed";
        }
    }

    show() {
        let objectRef = this.objectRef.current;
        if (appHelper.isEleDefined(objectRef)) {
            let params = {
                ele: objectRef,
                duration: objectConstants.SHOW_PANEL_DURATION,
                delay: 0,
                callback: null
            };
            animationHelper.fadeIn(params);
        }
    }

    getControlClass() {
        return this.state.status === objectConstants.STATUS_COMPLETE ? 'replay' : 'play';
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }

    setKeyboardAccessibility(event) {
        if (appHelper.isDefined(event)) {
            if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
                event.preventDefault();
                this.onPlayFunc();
            }
        }
    }

    onLinkClick(event) {
        event.stopPropagation();
    }

    render() {
        return (

            <div className="object-container" ref={this.objectRef}>>
                <div className={`asset-dialog-image`}>
                    <div className="asset-image-header">
                        <div className="title-col truncate-text-container">
                            <div className={`title ${this.getObjectStatusClass()}`}
                                 dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>

                        </div>
                        <div className="nav-col">
                            <button className={`btn guroo-btn`} onClick={this.props.closeDialog}>
                                {this.state.status === objectConstants.STATUS_COMPLETE || !this.state.screenObject.required_for_completion
                                    ?
                                    <span>{this.state.done_label}</span>
                                    :
                                    <span>{this.state.cancel_label}</span>
                                }
                            </button>
                        </div>
                    </div>
                    <div className={`asset-img-container video`}>
                        {this.state.status !== objectConstants.STATUS_COMPLETE && this.state.screenObject.required_for_completion
                            ?
                            <div className="video-instruction"
                                 dangerouslySetInnerHTML={{__html: this.state.video_instruction}}/>
                            :
                            null
                        }
                        <div className="video-js-container">
                            <div data-vjs-player>
                                {appHelper.isDefined(this.state.video.vtt) && this.state.video.vtt.length > 0
                                    ?
                                    <video ref={`video_${this.state.screenObject.asset_id}`} className="video-js">
                                        <track src={this.getCaptionPath(this.state.video.vtt)} kind="captions"
                                               srcLang={this.state.lang}
                                               label={dataHelper.toTitleCase(this.state.language_name)} default/>
                                    </video>
                                    :
                                    <video ref={`video_${this.state.screenObject.asset_id}`} className="video-js"/>
                                }
                            </div>
                        </div>
                        {
                            !this.state.isPlaying
                                ?
                                <div className={`video-thumbnail-wrapper ${this.getControlClass()}`}
                                     onClick={this.onPlayFunc} onKeyDown={this.setKeyboardAccessibility()}
                                     tabIndex="0"
                                     role="link">
                                    <img src={this.getImagePath(this.state.video.thumbnail)} alt=""/>
                                </div>
                                : null
                        }

                        {
                            appHelper.isDefined(this.state.locale.description) && this.state.locale.description !== null && this.state.locale.description.length > 0
                                ?
                                <div className="asset-desc">
                                    <div dangerouslySetInnerHTML={{__html: this.state.locale.description}}/>
                                </div>
                                :
                                null
                        }

                        {
                            appHelper.isDefined(this.state.video.txt) && this.state.video.txt.length > 0

                                ?
                                <div className="asset-desc">
                                    <a href={this.getCaptionPath(this.state.video.txt)} download target="_blank"
                                       tabIndex={0} onClick={this.onLinkClick}
                                       className="document">{this.state.download_transcript_label}</a>
                                </div>
                                :
                                null
                        }


                    </div>

                </div>
            </div>

        );
    }
}


/*config={{ file: {
                                             tracks: [
                                                 {kind: 'subtitles', src:  require(`../../../../moveToDist/${this.state.video.captions}`), srcLang: 'en', default: true}
                                             ]
                                         }}}*/
VideoJsPlayer.propTypes = {
    screenObject: PropTypes.object.isRequired,
    video: PropTypes.object.isRequired,
    callbacks: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    onAssetViewed: PropTypes.func.isRequired,
    closeDialog: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    userData: PropTypes.object.isRequired,
};

VideoJsPlayer.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        contentData: state.contentData,
        trackingData: state.trackingData,
        userData: state.userData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, appDataActions, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoJsPlayer);



/** WEBPACK FOOTER **
 ** ./src/components/objects/video/VideoJsPlayer.js
 **/